import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import UploadDocPopUp from './UploadDocPopUp';
import DocsViewer from './DocsViewer';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import { DEFAULT_API_URL, DEFAULT_LOCAL_PATH } from '../../constents';
import DocsNotePopup from './DocsNotePopup';
import { useSelector } from 'react-redux';

function DocsGridItems({
  item,
  handleToggleGrid,
  toggleGrid,
  patientId,
  handleReload,
}) {
  const [docsChangeOpen, setDocsChangeOpen] = useState(false);
  const [docsViewerOpen, setDocsViewerOpen] = useState(false);
  const [reviewPromt, setReviewPromt] = useState(false);
  const [sucPrams, setSucPrams] = useState('');
  const [docsId, setDocsId] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [docsNotePopUp, setDocsNotePopUp] = useState(false);
  const [docsNote, setDocsNote] = useState(false);

  const handleChangeDocs = (docsId) => {
    setDocsId(docsId);
    setDocsChangeOpen(true);
  };
  const handleClose = () => {
    setDocsId('');
    setDocsChangeOpen(false);
  };

  const handleViewerDocs = (docsId) => {
    setDocsId(docsId);
    setDocsViewerOpen(true);
  };
  const handleViewerClose = () => {
    setDocsId('');
    setDocsViewerOpen(false);
  };

  const handleDeleteDocs = (docsId) => {
    setReviewPromt(true);
    setSucPrams(docsId);
  };

  const handleRevertConfirm = async (docsId) => {
    try {
      const response = await post(
        'api/patient/ManagePatientDocument/deleteDocumentInfo',
        {
          loginUserId: user?.id,
          patientId: patientId,
          docId: docsId,
          table: '0',
        }
      );
      if (response.status === 200) {
        setUiMessage('suc', response.data?.msg);
        setReviewPromt(false);
        handleReload();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const openIntakeReview = async (
    dob = '',
    intakeId = 0,
    userType = 1,
    formId = 0
  ) => {
    try {
      const response = await post(
        'api/patient/ManagePatientDocument/checkLogin',
        {
          intakeId: intakeId,
          dob: dob,
          userType: userType,
          formId: formId,
          loginUserId: user?.id,
        }
      );
      if (response.status === 200) {
        if (parseInt(response.data?.status) === 1) {
          let url;
          if (response.data?.formId !== '') {
            url = `${DEFAULT_API_URL}/registration/profile/index/${response.data?.patientId}/${response.data?.intakeId}/${response.data?.userType}/${response.data?.formId}/${response.data?.ch_external_link_key}`;
          } else {
            url = `${DEFAULT_API_URL}/registration/profile/index/${response.data?.patientId}/${response.data?.intakeId}/${response.data?.userType}/${response.data?.ch_external_link_key}`;
          }
          window.open(url, '_blank');
        } else if (parseInt(response.data?.status) === 0) {
          setUiMessage('err', 'Wrong User Credentials');
        } else if (parseInt(response.data?.status) === 2) {
          setUiMessage(
            'err',
            'Link has been expire.Please contact to adminstrator!'
          );
        } else if (response.data?.status === 3) {
          setUiMessage(
            'err',
            'Unable to access this portal as it is not filled by patient till now.Please contact to adminstrator!'
          );
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleNoteClick = async (id, patientId) => {
    setDocsId(id);
    try {
      const response = await post(
        'api/patient/ManagePatientDocument/addEditDocumentPopup',
        {
          docId: id, //when edit document
          table: '0', //when edit document
          //locationC: '1',
          patientId: patientId,
          reconId: '',
        }
      );
      if (response?.status === 200) {
        setDocsNote(response?.data?.userNoteArr);
        setDocsNotePopUp(true);
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  const handleNotePopupClose = () => {
    setDocsId('');
    setDocsNotePopUp(false);
    handleReload();
  };

  return (
    <div className="docMaingrid-Pat-bdy-rw flex-sec">
      <span className="colm3">
        {item?.childDocumentDetailArr.length > 1 &&
          (toggleGrid ? (
            <span
              className="collapse-icon"
              onClick={handleToggleGrid}
              dangerouslySetInnerHTML={{ __html: '&#8722;' }}
            />
          ) : (
            <span
              className="collapse-icon"
              onClick={handleToggleGrid}
              dangerouslySetInnerHTML={{ __html: '&#43;' }}
            />
          ))}
      </span>
      {!patientId && (
        <span className="colm1">
          <span className="flex-sec link-color">
            <Link
              to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item?.patientId}`}
            >
              {item?.patientName}
            </Link>
          </span>
          <span className="flex-sec">
            ID: {item?.chartNo}, {item?.age} [{item?.sex}]
          </span>
        </span>
      )}

      <span className="colm1">{item?.doc_name}</span>
      <span className="colm1">{item?.doc_type}</span>
      <span className="colm2">{item?.doc_date}</span>
      <span className="colm5">{item?.docStatus}</span>
      <span className="colm4">
        <span className="colm4">
          {(() => {
            if (parseInt(item?.intake_form_id)) {
              return (
                <Link
                  onClick={() =>
                    openIntakeReview(
                      item?.dob,
                      item?.intake_id,
                      user?.userType,
                      item?.intake_form_id
                    )
                  }
                >
                  Access
                </Link>
              );
            } else if (item?.childDocumentDetailArr.length === 1) {
              return (
                <>
                  <Link onClick={() => handleViewerDocs(item?.id)}>
                    Preview
                  </Link>
                  <span className="red"> | </span>
                  <Link onClick={() => handleChangeDocs(item?.id)}>Change</Link>
                  <span className="red hide"> | </span>
                  <Link className="hide">Access</Link>
                  <span className="red"> | </span>
                  <Link onClick={() => handleDeleteDocs(item?.id)}>Delete</Link>
                </>
              );
            }
          })()}
        </span>
      </span>
      <span className="colm1">
        {item?.reviewer && (
          <>
            {item?.reviewer}
            <br />
            {item?.reviewerDt} | {item?.reviewerTime}
          </>
        )}
      </span>
      <span className="colm3 note-col">
        <div className=" note-count-bg">
          {/* {item?.noOfNote} */}
          <button
            style={{
              backgroundColor: 'orange',
              cursor: 'pointer',
              height: '16px',
              width: '34px',
              textAlign: 'center',
              color: 'white',
            }}
            onClick={() => handleNoteClick(item?.id, item?.patientId)}
          >
            {item?.noOfNote}
          </button>
        </div>
      </span>
      <span className="colm3">{item?.pages}</span>
      <span className="colm1">{item?.allocatedTo}</span>
      <span className="colm1">{item?.provider}</span>
      <span className="colm2">{item?.addedDt}</span>
      {docsChangeOpen && docsId && (
        <UploadDocPopUp
          close={handleClose}
          patientId={item?.patientId}
          docsId={docsId}
          handleReload={handleReload}
        />
      )}
      {docsViewerOpen && docsId && (
        <DocsViewer
          close={handleViewerClose}
          patientId={item?.patientId}
          docsId={docsId}
        />
      )}
      {reviewPromt && (
        <ConfirmDialog
          title={`Patient documents`}
          bodytext={`Do you really want to delete the selected document..?`}
          closeDialog={() => setReviewPromt(false)}
          successDialog={handleRevertConfirm}
          sucPrams={sucPrams}
        />
      )}
      {docsNotePopUp && (
        <DocsNotePopup
          handleCloseDocsNote={handleNotePopupClose}
          docId={docsId}
          docsNote={docsNote}
          handleUpdateDocsNote={(newData) => setDocsNote(newData)}
        />
      )}
    </div>
  );
}

export default DocsGridItems;
